<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 473.677 473.677" xml:space="preserve">
<path style="fill:#E3E3E3;" d="M0,236.842C0,106.024,106.036,0,236.835,0c130.807,0,236.842,106.024,236.842,236.842
	c0,130.792-106.036,236.835-236.842,236.835C106.036,473.677,0,367.634,0,236.842z"/>
<g>
	<path style="fill:#868686;" d="M347.915,281.983c0,14.076,0,28.148,0,42.227c-71.673,0-143.349,0-215.018,0
		c0-14.008,0-28.017,0-42.025c0-18.111-28.054-18.272-28.054-0.202c0,18.717,0,37.433,0,56.153c0,3.867,1.324,6.866,3.339,9.095
		c2.229,2.969,5.722,5.033,10.587,5.033c81.025,0,162.051,0,243.072,0c3.867,0,6.866-1.324,9.095-3.339
		c2.973-2.229,5.037-5.725,5.037-10.59c0-18.717,0-37.433,0-56.153C375.969,264.074,347.915,263.913,347.915,281.983z"/>
	<path style="fill:#868686;" d="M303.279,187.027c-15.4,0-30.795,0-46.195,0c0-23.32,0-46.64,0-69.956
		c0-27.168-42.078-27.407-42.078-0.303c0,23.421,0,46.838,0,70.259c-14.798,0-29.595,0-44.392,0
		c-0.273,0.004-0.542,0.03-0.808,0.071c-2.902,0.251-4.783,1.993-5.621,4.196c-1.088,2.184-1.062,4.85,0.856,7.161
		c0.217,0.299,0.46,0.572,0.725,0.83c22.056,22.041,44.101,44.09,66.149,66.134c2.715,2.711,7.229,2.64,9.917-0.052
		c22.127-22.131,44.25-44.262,66.377-66.392C312.494,194.693,309.345,187.027,303.279,187.027z"/>
</g>
</svg>